module.exports = __webpack_public_path__ + "static/img/5.8ce79f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/1/5.png
// module id = Tlkj
// module chunks = 1